import { render, staticRenderFns } from "./expert-introduction.vue?vue&type=template&id=eb06c098&scoped=true"
import script from "./expert-introduction.vue?vue&type=script&lang=js"
export * from "./expert-introduction.vue?vue&type=script&lang=js"
import style0 from "./expert-introduction.vue?vue&type=style&index=0&id=eb06c098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06c098",
  null
  
)

export default component.exports